import { render } from "./ReportesFiltros.vue?vue&type=template&id=b79a27d0&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesFiltros.vue?vue&type=script&lang=js"
export * from "./ReportesFiltros.vue?vue&type=script&lang=js"

import "./ReportesFiltros.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script